export function getUserRole() {
    let userRoles = {
        user: false,
        productAdmin: false,
        isGRPGroupAdmin: false,
        isGRPBranchAdmin: false,
        isGRPGroupUser: false
    }
    if (sessionStorage.getItem("userRoles")) {
        let savedUserRoles = JSON.parse(sessionStorage.getItem("userRoles"));
        if (savedUserRoles !== undefined) {
            userRoles = savedUserRoles;
        }
    }
    return userRoles
}

export const getGroupType = () => {
    let groupType = ""
    if (sessionStorage.getItem("groupType")) {
        console.log("sessionStorage.getItem(groupType)->groupType, ", sessionStorage.getItem("groupType"))
        groupType = JSON.parse(sessionStorage.getItem("groupType"));
        console.log("groupType before parse, ", groupType)
        groupType = JSON.parse(sessionStorage.getItem("groupType")).groupType;
        console.log("groupType after parse, ", groupType)
    }
    return groupType
}